import Quill from "quill";
const BlockEmbed = Quill.import("blots/block");

class LeftRightAlign extends BlockEmbed {
  static create(value) {
    const node = document.createElement("div");
    node.setAttribute("class", "ql-left-right");
    node.style.display = "flex";
    node.style.justifyContent = "space-between";

    node.innerHTML = `
      <em class='left-right' style='font-style: normal;'>${
        value ? value.left : "左侧文本"
      }</em>
      <em class='left-right' style='font-style: normal;'>${
        value ? value.right : "右侧文本"
      }</em>
    `;

    return node;
  }

  static value(node) {
    const spans = node.querySelectorAll(".left-right");
    return {
      left: spans[0] ? spans[0].textContent : "",
      right: spans[1] ? spans[1].textContent : "",
    };
  }
}

LeftRightAlign.blotName = "leftright"; // Blot 名称
LeftRightAlign.tagName = "div"; // HTML 标签

Quill.register(LeftRightAlign);



// WEBPACK FOOTER //
// ./src/plugins/quill/Blot.js